export const getMultiFileClassByExtension = (fileName) => {
  if (fileName) {
    const extension = fileName.split(".").pop();
    if (extension.toLowerCase() === "pdf") {
      return "pdf";
    } else if (extension.toLowerCase() === "txt") {
      return "file";
    } else if (
      extension.toLowerCase() === "img" ||
      extension.toLowerCase() === "jpeg" ||
      extension.toLowerCase() === "jpg" ||
      extension.toLowerCase() === "png" ||
      extension.toLowerCase() === "webp" ||
      extension.toLowerCase() === "svg"
    ) {
      return "img";
    } else if (
      extension.toLowerCase() === "xlsx" ||
      extension.toLowerCase() === "xls"
    ) {
      return "excel";
    } else if (extension.toLowerCase() === "docx" || 
      extension.toLowerCase() === "doc") {
      return "word";
    }
    else if (extension.toLowerCase() === "pptx" || 
    extension.toLowerCase() === "ppt") 
  {
      return "ppt";
    }
    else if (extension.toLowerCase() === "tiff") {
      return "tiff";
    } 
    else if (extension.toLowerCase() === "html" ||
    extension.toLowerCase() === "htm")
   {
      return "html";
    }else {
      return "deafult";
    }
  }
};
